var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadTile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.334,
    y: 40,
    width: 40,
    height: 40,
    rx: 5,
    transform: "rotate(-90 .334 40)",
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.834 11.5a2 2 0 0 1 2-2h5.45a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2h-5.45a2 2 0 0 1-2-2v-17z",
    fill: "#A1A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.385 11.5a2 2 0 0 1 2-2h5.45a2 2 0 0 1 2 2v5.45a2 2 0 0 1-2 2h-5.45a2 2 0 0 1-2-2V11.5zM21.385 23.05a2 2 0 0 1 2-2h5.45a2 2 0 0 1 2 2v5.45a2 2 0 0 1-2 2h-5.45a2 2 0 0 1-2-2v-5.45z",
    fill: "#A1A5B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadTile);
export default __webpack_public_path__ + "static/media/uploadTile.8681e86e68838c546b3631f4a7d45532.svg";
export { ForwardRef as ReactComponent };